
export const enum CONTENTFUL_KEY {
  BEST_PRACTICES = 'BEST_PRACTICES'
};